module.exports = __webpack_public_path__ + "static/img/drawer4.66dc9b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/page/drawer/drawer4.png
// module id = zk+R
// module chunks = 12